<div class="card card-default card-turnover-per">
  <div class="card-header">
    <h2>{{ Name }}</h2>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-4">
        <h1 class="amountCardFormat">{{ TurnOverWeek | localCurrency }}</h1>
        <p class="amountTitleCardFormat">{{'COMPONENTS.CARD-TURNOVER-WEEK' | translate}}</p>
      </div>
      <div class="col-4">
        <h1 class="amountCardFormat">{{ TurnOverMonth | localCurrency }}</h1>
        <p class="amountTitleCardFormat">{{'COMPONENTS.CARD-TURNOVER-MONTH' | translate}}</p>
      </div>
      <div class="col-4">
        <h1 class="amountCardFormat">{{ TurnOverTotal | localCurrency }}</h1>
        <p class="amountTitleCardFormat">{{'COMPONENTS.CARD-TURNOVER-TOTAL' | translate}}</p>
      </div>
    </div>
    <div>
      @if (progressPerc !== null) {
        <apx-chart  [chart]="progressPerc.chart"
          [xaxis]="progressPerc.xaxis"
          [colors]="progressPerc.colors"
          [labels]="progressPerc.labels"
          [dataLabels]="progressPerc.dataLabels"
          [plotOptions]="progressPerc.plotOptions"
          [series]="progressPerc.series">
        </apx-chart>
      }
    </div>
  </div>
</div>
